<script setup lang="ts">
  import { IconQC } from '@qicgroupdoha/qic-connect-ds'
  interface Props {
    icon: string
  }

  interface Slots {
    'default'(): void
  }

  defineProps<Props>()

  defineSlots<Slots>()
</script>

<template>
  <div class="accordion-button">
    <div class="accordion-button-icon">
      <!-- @vue-ignore -->
      <IconQC :name="icon" size="medium" :color="$qicConnect.colors.icn.srf.contrastLight" />
    </div>
    <div class="heading-6">
      <slot />
    </div>
    <!-- @vue-ignore -->
    <IconQC name="chevron-down" size="medium" :color="$qicConnect.colors.icn.srf.tertiary" />
  </div>
</template>

<style lang="scss" scoped>
  .accordion-button {
    display: flex;
    align-items: center;
    padding: var(--spacing-6) var(--spacing-7);
    gap: var(--spacing-4);
    cursor: pointer;
    background-color: var(--colorBgSrfTertiary);
    border-radius: var(--radius-5);

    & > :last-child {
      margin-inline-start: auto;
    }

    .accordion-button-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: var(--colorBgSrfAccentBrand);
      border-radius: 50%;
    }
  }
</style>
